import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';

export default class EntityStore {
    static _PropType = {
        setValue: PropTypes.func.isRequired,
        commitValue: PropTypes.func.isRequired,
        getValue: PropTypes.func.isRequired,
        getOriginalValue: PropTypes.func.isRequired,
        hasChanged: PropTypes.func.isRequired,
        isValid: PropTypes.func.isRequired,
        resetToOriginal: PropTypes.func.isRequired,
        resetToDefault: PropTypes.func.isRequired,
    };

    static PropTypes = PropTypes.shape(EntityStore._PropType);

    propNames = [];

    constructor(entityProps, ...otherProps) {
        this.propNames = Object.keys(entityProps);

        extendObservable(this, entityProps, ...otherProps);
    }

    setValue = action((obj, commit = false) => this.propNames.forEach((prop) => {
        if (obj[prop] !== undefined) {
            if (this[prop].setValue !== undefined) {
                this[prop].setValue(obj[prop], commit);
            } else {
                this[prop] = obj[prop];
            }
        }
    }));

    commitValue = (obj) => this.setValue(obj, true);

    getValue = () => this.propNames.reduce((acc, prop) => {
        if (this[prop] && this[prop].getValue !== undefined) {
            acc[prop] = this[prop].getValue();
        } else if (this[prop] && this[prop].value !== undefined) {
            acc[prop] = this[prop].value;
        } else {
            acc[prop] = this[prop];
        }
        return acc;
    }, {});

    getOriginalValue = () => this.propNames.reduce((acc, prop) => {
        if (this[prop] && this[prop].getOriginalValue !== undefined) {
            acc[prop] = this[prop].getOriginalValue();
        } else if (this[prop] && this[prop].originalValue !== undefined) {
            acc[prop] = this[prop].originalValue;
        }
        return acc;
    }, {});

    hasChanged = () => this.propNames.some((prop) => {
        if (this[prop] && this[prop].hasChanged !== undefined) {
            return this[prop].hasChanged();
        }
        return false;
    });

    isValid = () => this.propNames.every((prop) => {
        if (this[prop] && this[prop].isValid !== undefined) {
            if (typeof this[prop].isValid !== 'function') {
                // eslint-disable-next-line
                console.warn(`Caution: Bad API for '${prop}' property - isValid is not a function.`);
                return this[prop].isValid;
            }
            return this[prop].isValid();
        }
        return true;
    });

    resetToOriginal = () => this.propNames.forEach((prop) => {
        if (this[prop] && this[prop].resetToOriginal !== undefined) {
            this[prop].resetToOriginal();
        }
    });

    resetToDefault = (commit) => this.propNames.forEach((prop) => {
        if (this[prop] && this[prop].resetToDefault !== undefined) {
            this[prop].resetToDefault(commit);
        }
    });
}
